import Input from 'common/components/form/inputs/Input';
import { useFormState } from 'utils/hooks';

const Synonym = ({ state }) => {
  const { fields, changeField } = useFormState(state);
  return <Input {...fields.value} onChange={changeField('value')} />;
};

export default Synonym;
